/**
 * Add the Weekli widget to the DOM
 * @param {Config Object} WeekliConfig
 * @param {String} region downloadToken
 */
export function AddWeekliWidget(WeekliConfig, region) {
  // map to region code
  const regioncode = _mapToRegionCode(region);
  // Check for previous widget
  const previous_widget = document.getElementById(
    `weekli-widget-${WeekliConfig.ID}`
  );
  if (previous_widget) {
    window.updateWeekliWidget(`weekli-widget-${WeekliConfig.ID}`, {
      region: regioncode,
    });
  } else {
    const container = document.createElement("div");
    container.id = "weekliContainer";
    container.style = "order:4;";
    const title = document.createElement("div");
    title.className = "archiveTitle";
    title.innerText = "Prospekte";
    let promospot = document.getElementById("promoSpot");
    /*
    On mobile, there is no element with id promoSpot. The promospot is displayed in a div with class extra-promospot.
    */
    if (!promospot) {
      promospot = document.getElementsByClassName("extra-promospot")[0];
    }
    container.appendChild(title);

    // Insert new widget above promospot
    const weekli = document.createElement("div");
    weekli.id = `weekli-widget-${WeekliConfig.ID}`;
    weekli.className = "weekli-widget";
    weekli.style = "position:relative;width:auto;height:190px;margin:35px;";
    weekli.setAttribute("data-key", WeekliConfig.key);
    weekli.setAttribute("data-slot", WeekliConfig.ID);
    weekli.setAttribute("data-config", WeekliConfig.config);
    weekli.setAttribute("data-host", WeekliConfig.host);
    weekli.setAttribute("data-region", regioncode);
    container.appendChild(weekli);
    const script = document.createElement("script");
    script.setAttribute("async", true);
    script.id = "weekli-script";
    script.src =
      "https://static-weekli.net/static/widget/widget-loader-1.6.6.min.js";
    container.appendChild(script);

    if (promospot) {
      promospot.parentElement.insertBefore(container, promospot);
    }
  }
}

/**
 *
 * @param {String} regiontoken downloadToken
 * @returns {String} region code
 */
function _mapToRegionCode(regiontoken) {
  switch (regiontoken) {
    case "TWPKBBKBB":
      return "Kreiszeitung Böblinger Bote";
  }
}



// WEBPACK FOOTER //
// ./clients/swmh-kbb/js/engines/weekli.js